import { MdBusiness, MdStore, MdHome, MdBuild, MdFlashOn } from 'react-icons/md';

export const SECTORS = [
  { id: 'industrial', label: 'Industrial', icon: MdBusiness },
  { id: 'comercial', label: 'Comercial', icon: MdStore },
  { id: 'residencial', label: 'Residencial', icon: MdHome },
  { id: 'construccion', label: 'Construcción', icon: MdBuild },
  { id: 'energia', label: 'Energía', icon: MdFlashOn },
];
